module.exports = __webpack_public_path__ + "img/icon-marker-def.c9eeda46.png";